<div class="routes mt-4 bg-white px-3">
    <div
        class="grid h-14 cursor-pointer grid-cols-[90%_10%] items-center gap-x-1 border-b border-solid border-zinc-200 last:border-none dark:border-contrast-yellow"
        *ngFor="let routeGroup of routesGroups"
        (click)="redirectToRoutes(routeGroup)">
        <div class="text-base font-semibold leading-5 text-black dark:text-contrast-yellow">
            {{ this.env.EXPLORE?.ORIGINAL_ROUTE_NAME ? routeGroup?.name : (routeGroup.name | translate) }}
        </div>
        <div class="text-center dark:filter-yellow">
            <img [src]="(assetsPath$ | async) + '/img/explore/arrow-right.svg'" alt="Arrow Right" />
        </div>
    </div>
</div>
